import { PaymentState } from './index';
import { MutationTree } from 'vuex';
import { AdyenSession } from '@store/checkout/interfaces/adyenSession';
import { AdyenConfig } from "@store/checkout/interfaces/adyenConfig";
import { PpsSession } from "@store/checkout/interfaces/ppsSession";

export default {
    setAdyenSession(state, adyenSession: AdyenSession) {
        state.adyenSession = adyenSession;
    },
    setAdyenConfig(state, adyenConfig: AdyenConfig) {
        state.config = adyenConfig;
    },
    resetAdyenSessionId(state) {
        state.adyenSession.id = '';
    },
    setPpsSession(state, ppsSession: PpsSession) {
        state.ppsSession = ppsSession;
    },
    submitPpsForm(state) {
        state.ppsFinished = true;
    }
} as MutationTree<PaymentState>
